module.exports = __webpack_public_path__ + "img/logo-altera.df2aa4e2.png";